module.exports = __webpack_public_path__ + "img/banner.fef187a6.png";